import React, { useContext, useEffect, useState } from "react";
import style from "./Chatscard.module.css";
import { Chatcontext } from "../context/Chatcontext";
import { useNavigate } from "react-router-dom";
import {
  doc,
  getDoc,
  deleteDoc,
  getDocs,
  collection,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase/config";
import Overlay from "./Overlay";
import { AiOutlineUserAdd } from "react-icons/ai";
import Chatcard from "./Chatcard";
import { Adminlink } from "./Onlyadmin";
import { Authcontext } from "../context/Authcontext";
const Chatscard = (props) => {
  const chatcontext = useContext(Chatcontext);
  const { usertype } = useContext(Authcontext);
  const [users, setUsers] = useState([]);
  const [messages, setMessages] = useState();
  const navigate = useNavigate();
  const [chatusers, setChatusers] = useState([]);
  const [filteredusers, setFilterduser] = useState([]);
  const [overlay, setOverlay] = useState(false);
  const { currentuser } = useContext(Authcontext);
  const [unReadedMessage, setUnReadedMessage] = useState();
  const [roomUser, setRoomUser] = useState();

  const increaseUnreadMessages = async () => {
    try {
      //   console.log(roomUser,currentuser.uid)
      const docRef = doc(db, "roomuser", chatcontext?.chatid);
      const docSnap = await getDoc(docRef);

      if (docSnap?.exists()) {
        //   setRoomUser(docSnap?.data()?.users);
        const updatedUsers = docSnap?.data()?.users?.map((user) => {
          if (user?.user_id === currentuser?.uid) {
            return { ...user, un_read_message: 0 };
          }
          return user;
        });
        updatedUsers &&
          (await updateDoc(doc(db, "roomuser", chatcontext?.chatid), {
            users: updatedUsers,
          }));
      } else {
        console.log("No such document!");
        //   toast.warning("There is something wrong.");
      }

      // await fetchRoomUser();
    } catch (error) {
      console.error("Error increasing unread messages:", error);
    }
  };
  const fetchUnReadedMessage = () => {
    props?.chat?.users?.map((user) => {
      if (user?.user_id === currentuser?.uid) {
        setUnReadedMessage(user?.un_read_message);
      }
    });
  };
  useEffect(() => {
    fetchUnReadedMessage();
  }, []);
  useEffect(() => {
    fetchUnReadedMessage();
    increaseUnreadMessages();
  }, [currentuser?.uid, chatcontext?.chatid]);
  const tochat = async () => {
    await chatcontext.changefinish(props.finish);
    await chatcontext.changechat(props.chat.uid);
    {
      props.support === true
        ? navigate("/chat/messages")
        : navigate("/dashboard/chat");
    }
  };
  const topermission = () => {
    chatcontext.changechat(props.chat.uid);
    {
      usertype === "supervisor"
        ? navigate("/chat/chatpermission")
        : navigate("/dashboard/chatpermission");
    }
  };
  useEffect(() => {
    const isfinish = props.finish ? "finishedchats" : "roomuser";
    const fetchchats = async () => {
      const docdata = await getDoc(doc(db, "messages", props.chat.uid));
      setMessages(docdata?.data()?.message);
    };
    fetchchats();
    const chatuserid = async () => {
      const docRef = doc(db, isfinish, props.chat.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setChatusers(docSnap.data().users);
      } else {
        console.log("No such document!");
      }
    };
    chatuserid();
    const getallusers = async () => {
      const querySnapshot = await getDocs(collection(db, "users"));
      const demo = [];
      querySnapshot.forEach((doc) => {
        demo.push(doc.data());
      });
      setUsers(demo);
    };
    getallusers();
  }, []);
  const usersInChat = () => {
    setFilterduser(
      users.filter((user) =>
        chatusers.some((chatUser) => chatUser.user_id === user.uid)
      )
    );
    setOverlay(true);
  };
  return (
    <div className={style.card}>
      {overlay && (
        <Overlay>
          <div className={style.adduser}>
            <div className={style.addusernav}>
              <AiOutlineUserAdd size={50} />
            </div>
            <div className={style.users}>
              {filteredusers.map((client) => {
                return (
                  <Chatcard
                    key={client.uid}
                    addtochat={null}
                    userarray={chatusers}
                    client={client}
                  />
                );
              })}
            </div>
            <div className={style.adduserbutton}>
              <button onClick={() => setOverlay(false)}>اغلاق</button>
            </div>
          </div>
        </Overlay>
      )}
      <div className={style.imginfo}>
        {unReadedMessage > 0 ? (
          <p className={style.unreaded}>{unReadedMessage}</p>
        ) : null}

        <img src={props.chat.imageurl} />
        <p>{props.chat.name}</p>
      </div>
      <div className={style.cardcontent}>
        <p>عدد اعضاء المجموعة : {chatusers.length}</p>
        <p>عدد الرسائل علي المجموعة : {messages ? messages.length : "0"}</p>
        <p>
          تاريخ انشاء المجموعه : {props.chat.createdat.toDate().toDateString()}
        </p>
        <p> عدد الرسائل الغير مقروءه : {unReadedMessage >0?unReadedMessage:0}</p>
      </div>
      <div>
        {!props.permission && <button onClick={tochat}>انتقال للمجموعة</button>}
        {props.permission && (
          <button onClick={topermission}>انتقال للرسال المعلقه</button>
        )}
        <button onClick={usersInChat}> اعضاء المجموعة </button>
      </div>
      {!props.permission && (
        <Adminlink>
          <div>
            {!props.finish && (
              <button
                onClick={props.finishchat.bind(
                  this,
                  props.chat.uid,
                  props.chat
                )}>
                {" "}
                انتهاء المجموعة{" "}
              </button>
            )}
            <button
              className={style.deletechat}
              onClick={props.deletechat.bind(this, props.chat.uid)}>
              {" "}
              حذف المجموعه
            </button>
          </div>
        </Adminlink>
      )}
    </div>
  );
};
export default Chatscard;
